import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createSlots as _createSlots, openBlock as _openBlock, createBlock as _createBlock } from "vue";
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_g_entity_component = _resolveComponent("g-entity-component");
    const _component_portal_target = _resolveComponent("portal-target");
    const _component_g_window_view = _resolveComponent("g-window-view");
    return (_openBlock(), _createBlock(_component_g_window_view, {
        "show-header": false,
        "class-content": "content__no-marging content__no-overflow"
    }, _createSlots({
        default: _withCtx(() => [
            _createVNode(_component_g_entity_component, { window: _ctx.window }, null, 8, ["window"])
        ]),
        _: 2
    }, [
        (_ctx.hasPortalFooter)
            ? {
                name: "modal-footer",
                fn: _withCtx(() => [
                    _createVNode(_component_portal_target, {
                        name: '__footer_' + _ctx.currentWindow.id,
                        multiple: ""
                    }, null, 8, ["name"])
                ]),
                key: "0"
            }
            : undefined
    ]), 1024));
}
